module.exports = "1bf0aca3a522630baf97bf31c9eddd7f.png";


//////////////////
// WEBPACK FOOTER
// ./assets/sprites/temple-balcony-R.png
// module id = 50
// module chunks = 0